/**
 * Colours a business can give its printed documents (Settings → Document templates). They are
 * the document's own ink, not the app's, so they stay the same in the light and dark theme; each
 * prints well on white and keeps white letters readable on the coloured band.
 */
export const PAPER_ACCENTS = ['#1f2937', '#1d4ed8', '#0f766e', '#15803d', '#7c3aed', '#b91c1c', '#c2410c', '#0e7490'];
export const PAPER_DEFAULT_ACCENT = PAPER_ACCENTS[0]!;
